import React, { Component } from 'react';
import './fourohfour.css';
import Button from "../button/button";

class FourOhFour extends Component {
    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        return (
            <div className="fourohfour">
                <p>Je zou het niet denken, maar er is iets fout gegaan. De pagina kan niet worden gevonden.</p>
                <p><Button color="yellow" href="/" name="Ga naar home" block={true}/></p>
            </div>
        );
    }
}

export default FourOhFour;



// WEBPACK FOOTER //
// ./src/components/fourohfour/fourohfour.js